import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: JSON.parse(sessionStorage.getItem('userData')),
  error: null,
  token: sessionStorage.getItem('token')
}

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    }
  }
})

export const selectorUser = (state) => state.dataSlice.user
export const selectorToken = (state) => state.dataSlice.token

export const { setUser, setToken } = dataSlice.actions

export default dataSlice.reducer
